(function () {
  function bindForm(form) {
    if (form.dataset.searchNoRedirectBound === 'true') return;
    form.dataset.searchNoRedirectBound = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var input = form.querySelector('input[type="search"]');
      var wrapper = form.closest('predictive-search');

      if (!input || !input.value.trim() || !wrapper) return;

      if (wrapper.hasAttribute('results')) {
        wrapper.open();
      } else if (typeof wrapper.onChange === 'function') {
        wrapper.onChange();
      }
    });
  }

  function bind(root) {
    (root || document).querySelectorAll('form[data-search-no-redirect]').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind();
    });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
